/* eslint-disable no-prototype-builtins */

export const walletCurrenciesTypes = {
  CRYPTO: 'crypto',
  FIAT: 'fiat',
  INTERNAL: 'internal',
};

export const WalletScreens = {
  SELECT_CURRENCY: 'select_currency',
  DEPOSIT_WALLET_SELECTION: 'deposit_wallet_selection',
  WITHDRAW_WALLET_SELECTION: 'withdraw_wallet_selection',
  LEDGER_DEPOSIT: 'ledger_deposit',
  FIAT_DEPOSIT: 'fiat_deposit',
  FIAT_WITHDRAWAL: 'fiat_withdrawal',
  FIAT_WITHDRAWAL_REVIEW: 'fiat_withdrawal_review',
  FIAT_WITHDRAWAL_DETAILS: 'fiat_withdrawal_details',
  VERIFY_TRANSACTION: 'verify_transaction',
  RECEIVE: 'receive',
  RECEIVE_DETAILS: 'receive_details',
  TRANSACTION_PROCESSED: 'transaction_processed',
  LOADER: 'loader',
};

export const NETWORK_FEES_TYPES = {
  Slow: 'slow',
  Medium: 'medium',
  Fast: 'fast',
};

export const MODAL_SCREENS = {
  TOTAL_CHANGE_INFO: 'total_change_info',
};

// refactor is needed
export const modalsScreensNames = {
  TRANSACTION_DETAILS: 'transactions_details',
};

export const BANK_REQUESTS_COINS = {
  GBP: 'gbp',
  EUR: 'eur',
  EURS: 'eurs',
  EURC: 'eurc',
  EURT: 'eurt',
  EUROC: 'euroc',
  USDT: 'usdt',
  USDC: 'usdc',
  USD: 'usd',
};

const defaultBankWithdrawFields = () => ['recipientIban', 'recipientBic', 'recipientBank'];

const _BANK_WITHDRAW_REQUIRED_FIELDS = {
  eur: ['recipientIban', 'recipientBic', 'recipientBank'],
  eurs: ['recipientIban', 'recipientBic', 'recipientBank'],
  eurt: ['recipientIban', 'recipientBic', 'recipientBank'],
  gbp: ['recipientAccountNumber', 'recipientSortCode', 'recipientBank'],
  usd: ['recipientIban', 'recipientBic', 'recipientBankCountry'],
  usdt: ['recipientIban', 'recipientBic', 'recipientBankCountry'],
  usdc: ['recipientIban', 'recipientBic', 'recipientBankCountry'],
};

export const BANK_WITHDRAW_REQUIRED_FIELDS = new Proxy(_BANK_WITHDRAW_REQUIRED_FIELDS, {
  get: (object, property) =>
    object.hasOwnProperty(property.toLowerCase())
      ? object[property.toLowerCase()]
      : defaultBankWithdrawFields(),
});

export const AMOUNT_INPUT_MAX_LENGTH = 15;

export const SEND_MODES = {
  ADDRESS: 'address',
  PHONE_NUMBER: 'phoneNumber',
};

export const SendCryptoScreensFlow = {
  SEND_CRYPTO: 'send_crypto',
  CONFIRM_TRANSACTION: 'confirm_transaction',
  CONFIRM_NEW_AMOUNT_TRANSACTION: 'confirm_new_amount_transaction',
  VERIFY_TRANSACTION: 'verify_transaction',
  WHITELIST_ADDRESS_TYPE: 'address_type',
  WHITELIST_WALLET_ADDRESS_LEDGER: 'whitelist_wallet_address_ledger',
  WHITELIST_WALLET_ADDRESS_EXTERNAL: 'whitelist_wallet_address_external',
  WHITELIST_VERIFY: 'whitelist_verify',
  WHITELIST_SELECT_ADDRESS: 'whitelist_select_address',
  WHITELIST_MANAGE_ADDRESSES: 'whitelist_manage_addresses',
  WHITELIST_DELETE_ADDRESS: 'whitelist_delete_wallet',
  WHITELIST_CHANGE_WALLET: 'whitelist_change_wallet',
  WHITELIST_ADD_EXTERNAL: 'whitelist_add_external',
};

export const exchangeScreensFlow = {
  MAIN: 'main',
  CONFIRM_EXCHANGE: 'confirm_exchange',
  CURRENCIES: 'currencies',
};

export const exchangeTypes = {
  SELL: 'sell',
  BUY: 'buy',
  CONVERT: 'convert',
};

export const hiddenTransactionTypes = [
  'cryptodraft_debit_collateral',
  'cryptodraft_collateral_liquidation',
  'fee',
  'asset_lock',
  'asset_release',
];

export const actionTypes = {
  WITHDRAW: 'withdraw',
  ADD_FUNDS: 'add_funds',
};
